import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EuiInputRadioComponent } from './eui-input-radio.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiInputRadioComponent,
    ],
    exports: [
        EuiInputRadioComponent,
    ],
})
export class EuiInputRadioModule { }
